import { render, staticRenderFns } from "./vehicle_status.vue?vue&type=template&id=93bb01aa&scoped=true&"
import script from "./vehicle_status.vue?vue&type=script&lang=js&"
export * from "./vehicle_status.vue?vue&type=script&lang=js&"
import style0 from "./vehicle_status.vue?vue&type=style&index=0&id=93bb01aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93bb01aa",
  null
  
)

export default component.exports